import { ItemForm } from "../ItemForm";

export interface AddItemProps {}

export const AddItem = () => {
  return <ItemForm />;
};
